/**
 * 智算一站式 AI 平台 landing URL 构造工具。
 *
 * token 由本平台前端注入（localStorage userToken，见 @/utils/auth.getToken），
 * AI 平台服务端拿到 token 后回查本平台 /sso/getUserInfoByUserToken（带 secretkey）
 * 落实 SSO，从而保证 NCNP → 本平台 → AI 平台 三方用户统一。
 *
 * 集中在此以便 router/permission.js 的智算菜单外链与 /console/transit 中转组件复用，
 * 避免落地地址散落多处。
 */
import { getToken } from "@/utils/auth";

export const AI_LANDING_BASE = "https://ai.ssc.net.cn:8443/outer/landing";

/**
 * 构造智算一站式 AI 平台 landing URL。
 * @param {string} [target="aistudio"] redirect_target：default/computility/aistudio
 * @returns {string} 带 token 的 landing 完整 URL
 */
export function buildAiLandingUrl(target = "aistudio") {
  return `${AI_LANDING_BASE}?type=Shanghai&redirect_target=${target}&token=${getToken()}`;
}
